/*
 * This component is deprecated as it has been replaced by the more flexible DropdownLink.
 * Do not use this component.
 */
import React from 'react';
import DropdownLink, { Props as DropdownLinkProps } from '../DropdownLink';

export interface Props extends Omit<DropdownLinkProps, 'expanded'> {
  open: boolean;
}

export const TextDropdownButton: React.FC<Props> = ({
  open,
  onClick,
  ...restProps
}) => <DropdownLink {...restProps} onClick={onClick} expanded={open} />;

TextDropdownButton.displayName = 'TextDropdownButton';
export default TextDropdownButton;
